import React, { useEffect, useState, FormEvent } from "react";
import "./verifyPhoneNumberv2.scss";
// material ui
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import CircularIndeterminate from "../../../components/CircularIndeterminate";
//  cookie functions
import { erase, setCookie } from "../../../helper/cookieFunction";
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../store';
import { RootState } from '../../../store/reducers';
// svg icons
import IMAGES from "../../../assets/images"
import Looks5OutlinedIcon from '@mui/icons-material/Looks5Outlined';
import { Link, useNavigate } from "react-router-dom";
import { authService } from "../../../services";
import Page from "../../../components/Page"
import TextField from '@mui/material/TextField';
import InputMaskField from "../../../components/react-input-mask/inputfield"
import { ConstructionOutlined } from "@mui/icons-material";
import { handleUserInfo } from "../../../helper/customObj";

const renderButton = (t: any) => (buttonProps: any) => {
  return (
    <button className="createAccountAndforgotPass px-1" {...buttonProps}>
      {buttonProps.remainingTime !== 0 ? (
        <span className="text-muted">
          {t("Forms.send-again")}
          {/* Send again */}
        </span>
      ) : (
        <span>
          {/* {t("Forms.send-again")}  */}
          Send again
        </span>
      )}
    </button>
  );
};
function VerifyPhoneNumberv2() {
  const state = useSelector((state: RootState) => state.auth)
  // console.log(state.shopUrl)
  const { formData } = useSelector((state: RootState) => state.auth)
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [OTP, setOTP] = useState("");
  const { langValueState, freezScreenState, alertMessageState, userInfoState } = bindActionCreators(actionCreators, dispatch);
  const { t } = useTranslation();
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");
  const [sendAgain, setSendAgain] = useState(false)
  const [timer, setTimer] = useState(60)
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1)
  const [signUpForm, setSignUpForm] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });

  const handleSendOtp = async () => {

    try {
      setLoading(true);
      freezScreenState(true);
      if (formData.phoneCode && formData.phoneNumber !== "") {
        let mobile_no = `${formData.phoneCode}${formData.phoneNumber}`;
        const response = await authService.guestOtp(formData.phoneCode,formData.phoneNumber, formData.firstName);
        freezScreenState(false);
        if (response.data.data === true) {
          setLoading(false);
          freezScreenState(false);
          alertMessageState({
            type: "success",
            show: true,
            message: response.data.message,
          });
          setOTP("")


        } else {
          freezScreenState(false);
          alertMessageState({
            type: "error",
            show: true,
            message: response.data.message,
          });
      
        } 
      } else {
        alertMessageState({
          type: "error",
          show: true,
          message: t("Login.plz-fill"),
        });
        freezScreenState(false);
      }
      setSendAgain(false)
    } catch (e) {
      // // console.log(e);
      setLoading(false);
      alertMessageState({
        type: "error",
        show: true,
        message: e,
      });
      setSendAgain(false)
    }
  };

  useEffect(() => {
    if (!sendAgain) {
      var timeleft = 59;
      var downloadTimer = setInterval(function () {
        if (timeleft <= 0) {
          clearInterval(downloadTimer);
          setSendAgain(true)
        }
        setTimer(timeleft)
        timeleft -= 1;
      }
        , 1000);
    }
  }, [sendAgain])

  useEffect(() => {
    const handleCheckOtp = async () => {
      setLoading(true);
      freezScreenState(true);
      try {
        const phoneNumber = formData.phoneNumber
        const countryCode = String(formData.phoneCode || "965");
        const firstName = formData.firstName ? formData.firstName : null
        const response = await authService.checkGuestOtp({ OTP, phoneNumber, countryCode,firstName });
        // console.log(response)
        if (response.data.success === true) {
          if (response.data.data) {
            // console.log("new", response.data.data.new)
            let userInfo = handleUserInfo(response.data.data)
            // console.log("handleUserInfo",userInfo)
            localStorage.setItem(`userInfo`, JSON.stringify(userInfo));
            setCookie("Profile", JSON.stringify(userInfo), 30); // set cookie by Profile bcz we are using it by Profile on shop and pay
            setCookie("tokenAuth", response.data.data.token, 365);
            userInfoState(userInfo)
            // if (response.data.data.new === false) {
            // } else {
            //   navigate("/account")
            // }
            erase('redirect')
            if (state.shopUrl) {
              const baseUrl = "https://booking.enabill.com";
              let redirectUrl = state.shopUrl;
          
              // Check if the URL starts with the base URL
              if (state.shopUrl.startsWith(baseUrl)) {
                  // Append ?appLoggedIn only if it is exactly the base URL without a path
                  if (state.shopUrl === baseUrl || state.shopUrl === `${baseUrl}/`) {
                      redirectUrl = `${baseUrl}&appLoggedIn`;
                  }
              }
          
              // Redirect to the appropriate URL
              window.location.replace(redirectUrl);
          } else {
              setLoading(false);
              freezScreenState(false);
              alertMessageState({
                type: "error",
                show: true,
                message: "No domain to redirect!",
              });
              setOTP("")
             
            }
          } else if (response.data.data === false) {
            setLoading(false);
            freezScreenState(false);
            setOTP("")
            alertMessageState({
              type: "error",
              show: true,
              message: response.data.message,
            });
            if(count > 4){
              navigate("/login")
            
          }

          }
        }
        else {
          setLoading(false);
          freezScreenState(false);
          alertMessageState({
            type: "error",
            show: true,
            message: response.data.message,
          });
        }


      } catch (e) {
        setLoading(false);
        freezScreenState(false);
        alertMessageState({
          type: "error",
          show: true,
          message: e
        });
        // console.log(e)

      }
    };
    if (OTP.length === 5) {
      handleCheckOtp();
      setCount(1 + count)
    }
  }, [OTP]);

  const handlechangeSetOtp = (e: Event | any) => {
    if (e.target.value.length < 6 || e.nativeEvent.data === null) {
      setOTP(e.target.value)
    }
    
  }

  return (
    <div>
      <Dialog
        id="verifyModal"
        fullWidth={fullWidth}
        // maxWidth={maxWidth}
        open={true}
        BackdropProps={{ invisible: true }}
      // onClose={handleClose}

      >
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularIndeterminate />
          </Backdrop>
        )}
        <DialogContent>
          <Page title="verify">
            <div
              className={`${state.langValue === "ar" ? "directionRtl" : ""}`}
              id="verifyPhoneNumberMainv2"
            >
              <div className="row pt-2 ">
                <div className="col-md-12 d-flex justify-content-between classforPaddinglogo ">
                  <img src={IMAGES.enabill} alt="enabill-logo" />

                  <div>
                    {state.langValue == "ar" ? (
                      <Button
                        className="px-5 mx-2 arabicBtn"
                        variant="contained"
                        onClick={() => langValueState("en")}
                      >
                        English
                      </Button>
                    ) : (
                      <Button
                        className="px-5  arabicBtn"
                        variant="contained"
                        onClick={() => langValueState("ar")}
                      >
                        العربيه
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <h1
                className={`familyManrope800 mt-3 ${state.langValue === "ar" ? "d-flex" : ""
                  }`}
              >
                {t("Forms.verify-number")}
              </h1>
              <div
                className={`familyManrope600 d-flex flex-wrap loginTitle m-0 ${state.langValue === "ar" ? "d-flex text-right" : ""
                  }`}
              >
                <div>{t("Forms.enter-code")}</div>
                <div className="textEB5B5E direction-ltr">+{formData.phoneCode} {formData.phoneNumber}</div>
                {/* +{phone.phoneCode} {phone.phoneNumber} */}
              </div>

              <div

                className={`optMain mt-3 ${state.langValue === "ar" ? "classforArabic" : ""
                  }`}
              >
                <InputMaskField value={OTP}
                  onChange={handlechangeSetOtp} inputProps={{ maxLength: 5, inputMode: "numeric" }}
                  label={null}
                  variant="outlined"
                  type="tel"
                  mask="99999"
                  id="outlined-basic" name="phoneNumber"
                  autoFocus={true}
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                  }}
                />
              </div>
              <div className="row mt-3 pb-2">
                <div
                  className={`col-12 ${state.langValue === "ar" ? "" : ""
                    }`}
                >
                 
                  <hr />
                  <div className="notRegisterMain py-2"> <table >
                    <tbody>
                      <tr className="familyManrope600 ">
                        <td><img className="img-fluid" src={IMAGES.time} alt="" /></td>
                        <td>  <span className="px-2 ">
                          <span className="textBlack">
                            {" "}
                            {t("Forms.did-not-recieve")} ? </span>

                        </span></td>
                        {sendAgain ? <td onClick={handleSendOtp} className="cursorPointer btnEffect px-2 familyManrope700 notRegister">{t("Forms.send-again")}</td> : <td className="px-1"> ({timer} sec )</td>}

                      </tr>
                    </tbody>

                  </table></div>
                  <hr />
                  <div>
                    <table>  
                      <tbody>
                        <tr className="familyManrope700  notRegisterMain">
                          <td><img className="img-fluid" src={IMAGES.dialpad} alt="" /></td>
                          <td className="notRegister  btnEffect cursorPointer px-2" onClick={() => navigate('/login')}>{t("Forms.differ-number")}</td>
                        </tr>
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Page>

        </DialogContent>
      </Dialog>
    </div>
  );
}
export default withTranslation()(VerifyPhoneNumberv2);